import { FetchiosError } from "@caprikorn/dynamo-utils";
import { useMutation } from "@tanstack/react-query";

import { unauthenticatedApiEcmsHttp } from "@services/http";

const postRefreshToken = async ({
  refreshToken,
  username,
}: {
  refreshToken: string | null;
  username: string | null;
}) => {
  if (!refreshToken || !username) {
    throw new FetchiosError("session expired", 401);
  }

  const response = await unauthenticatedApiEcmsHttp.post<{
    accessToken: string;
  }>("/public/refresh-token", {
    username,
    refreshToken,
  });

  return response.data;
};

export const usePostRefreshToken = () =>
  useMutation({
    mutationFn: postRefreshToken,
  });
